import { CommonDateModule, ServiceResponseModule, WidgetDefinition, WidgetRegistryService } from '@sdbn/common';
import { NgModule } from '@angular/core';

import { ArticleTypeModule } from './article-types/article-type.module';
import { ArticleTypeAdminComponent } from './article-types/components/article-type-admin/article-type-admin.component';
import { CatalogAdminComponent } from './catalog/components/catalog-admin/catalog-admin.component';
import { BasicArticleAdminComponent } from '../erp-articles/basicarticle/basicarticle-admin/basicarticle-admin.component';
import { BasicArticeModule } from './basicarticle/basicarticle.module';
import { CommonTranslationModule } from '@sdbn/common';
import { CatalogModule } from './catalog/catalog.module';

@NgModule({
  declarations: [
  ],
  imports: [
    ArticleTypeModule,
    BasicArticeModule,
    CatalogModule,
    CommonTranslationModule,
    ServiceResponseModule,
    CommonDateModule
  ],
  exports: [

  ]
})
export class ErpArticleModule {

  constructor(
    private widgetRegistryService: WidgetRegistryService
  ) {

    // register widgets
    widgetRegistryService.registerWidget(new WidgetDefinition({
      key: 'erpArticleTypeAdmin',
      name: 'Article Types Admin',
      description: 'TBD',
      icon: 'fa-light fa-users-class',
      groupIdentifier: 'erp-article',
      widgetComponent: ArticleTypeAdminComponent,
      editorComponent: null,
      autoreload: false
    }));

    // register widgets
    widgetRegistryService.registerWidget(new WidgetDefinition({
      key: 'erpArticleCatalogAdmin',
      name: 'Article Catalog Admin',
      description: 'TBD',
      icon: 'fa-light fa-folder-tree',
      groupIdentifier: 'erp-article',
      widgetComponent: CatalogAdminComponent,
      editorComponent: null,
      autoreload: false
    }));

    // register widgets
    widgetRegistryService.registerWidget(new WidgetDefinition({
      key: 'erpBasicArticleAdmin',
      name: 'Basicarticle Admin',
      description: 'TBD',
      icon: 'fa-light fa-list-tree',
      groupIdentifier: 'erp-article',
      widgetComponent: BasicArticleAdminComponent,
      editorComponent: null,
      autoreload: false
    }));

  }

}
